import React from 'react';
import './unavailable.css';

export default ({ t }) => (
  <div className="unavailable__wrapper">
    <img src="/icons/slotsUnavailable.svg" className="unavailable__img" alt="slots unavailable" />
    <p>{t('NO_SLOTS_AVAILABLE')}</p>
  </div>
)